// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { default } from '/Users/jilin/projects/antd/rc-dialog/node_modules/dumi/theme-default/slots/PreviewerActions/index.js';
